import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { storage } from 'utils';
import BannerButtons from './bannerButtons';
import { styled } from 'dripsy';
import { View, Text, CloseX, Touchable, InlineLink } from 'modules/styled';

const mobilePhone = {
  position: 'absolute',
  bottom: 0,
  width: '80vw',
  right: '-40px',
  opacity: '.3',
};

const SplashText = styled(Text)({
  fontFamily: 'variant.text.link',
  color: 'black',
});

const SubHeader = styled(Text)({
  fontFamily: 'serif',
  display: 'inline',
});

class Splash extends Component {
  static propTypes = {
    hideCloseButton: PropTypes.bool,
    location: PropTypes.object,
    history: PropTypes.object,
    screenSize: PropTypes.number,
    overRideDismiss: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    this.onScroll = this.onScroll.bind(this);
  }

  state = {
    isDismissed: true,
  };

  componentDidMount = async () => {
    window.addEventListener('scroll', this.onScroll);
    const isDismissed = await storage.isDismissed('splashDismissed', 5);
    this.setState({
      isDismissed,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isDismissed !== this.state.isDismissed) {
      this.onScroll();
    }
  }

  onScroll() {
    if (!this.phone) return;
    this.phone.style.transform = '';
    const top = this.phone.getBoundingClientRect().top - 100;
    const y = Math.max(-top / 3, 0);
    this.phone.style.transform = `translateX(0) translateY(${y}px)`;
  }

  dismiss = () => {
    const now = new Date().getTime();
    storage.set('splashDismissed', now);
    this.setState({ isDismissed: true });
  };

  render() {
    const { location, history, screenSize, overRideDismiss } = this.props;

    if (this.state.isDismissed && !overRideDismiss) {
      return null;
    }

    const img = '/img/hand-transparent.png';
    const learnMoreUrl =
      'https://blog.relevant.community/relevant-curated-by-communities-not-clicks-ba8d346c47da';

    return (
      <View
        ref={(c) => (this.container = c)}
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          flexDirection: 'row',
          overflow: 'hidden',
          variant: 'borders.navBorder',
          borderBottomWidth: 1,
          position: 'relative',
          maxHeight: '550px',
        }}
      >
        <Touchable style={{ position: 'static', zIndex: 10 }} onPress={this.dismiss}>
          <CloseX
            sx={{
              width: 3,
              height: 3,
              top: [4, 6],
              right: [3, 6],
            }}
            resizeMode={'contain'}
            source={require('public/img/x.png')}
          />
        </Touchable>
        <View
          sx={{
            justifyContent: 'center',
            alignItems: ['stretch', 'flex-start'],
            flex: 1,
            mt: [3, 6],
            mr: [2, 0],
            mb: [2, 6],
            ml: [2, 12],
          }}
          webContainerSx={{ flex: [1] }} // https://github.com/nandorojo/dripsy/issues/34
        >
          <SplashText sx={{ mr: [3, 0], fontSize: [4, 6], lineHeight: [4, 6] }}>
            Information curated by humans, not algorithms.
          </SplashText>
          <SubHeader
            sx={{
              mr: [3, 0],
              mt: [2, 5],
              mb: [0, 6],
              fontSize: [2, 3],
              lineHeight: [2, 3],
            }}
          >
            Join a{' '}
            <InlineLink inline to="/communities">
              community
            </InlineLink>
            , curate content and earn rewards.{' '}
            <InlineLink
              to={learnMoreUrl}
              external
              target="_blank"
              display="inline"
              sx={{ textDecorationStyle: 'underline' }}
            >
              Learn More
            </InlineLink>
          </SubHeader>
          <BannerButtons location={location} history={history} />
        </View>
        <View
          webContainerSx={{
            flex: [0, 0.65],
            zIndex: -1,
          }} // https://github.com/nandorojo/dripsy/issues/34
          sx={{
            flex: 0.65,
            alignSelf: 'flex-end',
            transformOrigin: 'bottom',
            zIndex: -1,
            maxHeight: '400px',
            ...(screenSize ? mobilePhone : {}),
          }}
        >
          <img
            style={{ width: '100%' }}
            ref={(c) => (this.phone = c)}
            onLoad={this.onScroll}
            src={img}
            alt="phone"
          />
        </View>
      </View>
    );
  }
}

export default withRouter(Splash);
